import component from "element-plus/es/components/tree-select/src/tree-select-option.mjs";
import { createRouter, createWebHistory } from "vue-router";
const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/HomeView.vue"), // 首页
  },
  {
    path: "/recruit",
    name: "Recruit",
    component: () => import("../views/RecruitView.vue"), // 千音计划
  },
  {
    path: "/join",
    name: "join",
    component: () => import("../views/JoinView.vue"), // 加入我们
  },
  // {
  //   path: "/train",
  //   name: "Train",
  //   component: () => import("../views/train/TrainView.vue"), //主播培训
  //   children: [
  //     {
  //       path: "/trainlogin", //登陆页面
  //       component: () => import("../views/train/component/TrainloginForm.vue"),
  //     },
  //     {
  //       path: "/livepage", //直播页面
  //       component: () => import("../views/train/component/LivePage.vue"),
  //     },
  //     {
  //       path: "/replay", //回放页面
  //       component: () => import("../views/train/component/ReplayPage.vue"),
  //     },
  //   ],
  // },
  {
    path:'/product',
    name:'Product',
    component:()=>import("../views/ProductView.vue")
  }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});
export default router;
